module.exports = __webpack_public_path__ + "img/SyQel.23698817.svg";